export default __webpack_public_path__ + "static/media/addpasta.c7488bd0.svg";